module.exports = __webpack_public_path__ + "img/skyline-landmarks@2x.c044af6.png";